<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 27 18">
    <path
      d="M19.6564 1.125V0H16.3128V1.125H10.74V0H7.39639V1.125H4.05273V18H23.0001V1.125H19.6564ZM17.4273 1.125H18.5419V3.375H17.4273V1.125ZM8.51094 1.125H9.62549V3.375H8.51094V1.125ZM21.8856 16.875H5.16729V6.84H21.8856V16.875ZM5.16729 5.715V2.25H7.39639V4.5H10.74V2.25H16.3128V4.5H19.6564V2.25H21.8856V5.715H5.16729Z"
      :class="colorClass"
    />
    <path d="M20.5 9V10.125H6V9H20.5Z" :class="colorClass" />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
